import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Container, Title } from './payment.styles';
import messages from './messages';
import { Summary } from './summary';
import { PaymentForm } from '../../../shared/components/paymentForm';

export class Payment extends PureComponent {
  render() {
    return (
      <Container>
        <Title>
          <FormattedMessage {...messages.title} />
        </Title>
        <Summary />
        <PaymentForm />
      </Container>
    );
  }
}
